export function flattenMessages(nestedMessages, prefix = '') {
  if (nestedMessages) {
    return Object.keys(nestedMessages).reduce((messages, key) => {
      let value = nestedMessages[key];
      let prefixedKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === 'string') {
        // eslint-disable-next-line no-param-reassign -- needed
        messages[prefixedKey] = value;
      } else {
        Object.assign(messages, flattenMessages(value, prefixedKey));
      }
      return messages;
    }, {});
  } return {};
}
